import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import ApexCharts from 'apexcharts';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { ColorUtil } from 'src/app/common/util';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';

@Component({
  selector: 'app-budget-sells-report',
  templateUrl: './budget-sells-report.component.html',
  styleUrls: ['./budget-sells-report.component.scss']
})
export class BudgetSellsReportComponent implements OnInit, OnChanges {
  @Input() warehouse = null;
  months = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  }

  constructor(
    private accountingService: AccountingReportService,
    private toastService: ToastrService
  ) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['warehouse'] && !changes['warehouse'].isFirstChange()) {
      this.updateChart();
    }
  }

  ngOnInit() {
    this.updateChart();
  }

  updateChart() {
    document.getElementById("apex-distributed-column-chart").innerHTML = "";
    this.accountingService.getBudgetSells(this.warehouse).subscribe({
      next: (response: ResponseObject) => {
        console.log(response.data);
        var categories = [];
        var data = [];
        var total = { name: 'Total', data: [] };
        var total_taxes = { name: 'Total de Impuestos', data: [] };
        var budget = { name: 'Presupuesto', data: [] };
        var basicColors = ["#87CBAC", "#90FFDC", "#8DE4FF"];
        var colors = [];
        response.data.forEach((r) => {
          total.data.push(r.total);
          total_taxes.data.push(r.total_taxes);
          budget.data.push(r.budget);
          categories.push(r.year + " - " + this.months[r.month])
        });
        basicColors.forEach((basic) => {
          categories.forEach((c) => {
            colors.push(basic);
          })
        })

        data.push(budget);
        data.push(total);
        data.push(total_taxes);

        var options = {
          series: data,
          chart: {
            height: 350,
            type: 'bar',
            events: {
              click: function (chart, w, e) {
                // console.log(chart, w, e)
              }
            }
          },
          plotOptions: {
            bar: {
              columnWidth: '45%'
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: categories
          },
          tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              console.log(series,seriesIndex,dataPointIndex,w);
              
              var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

              return '<div style="padding:0.5em; margin:0;"><p class="h6">' + w.globals.labels[dataPointIndex] + '<span style="color:'+w.globals.colors[dataPointIndex]+';">⬤</span></p>' +
                '<p class="h4" style="color:'+w.globals.colors[dataPointIndex]+';"><b>Q ' + new Intl.NumberFormat('en-US').format(series[seriesIndex][dataPointIndex]) + '</b></p></div>';
            }
          }
        };

        var chart = new ApexCharts(document.querySelector("#apex-distributed-column-chart"), options);
        chart.render();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

}
